export default {
      id: "copy-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#copy-usage",
      toString: function () {
        return this.url;
      }
    }